var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLocation = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 15 18"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#2F1F19",
  d: "M3.8 1a7.5 7.5 0 0 1 7.5 0C13.6 2.6 15 5 15 7.8S13.4 13 11.6 15A20 20 0 0 1 8 18l-.5.1-.4-.1c-2-1.3-3.7-3-5.2-4.8A9.8 9.8 0 0 1 0 7.6v-.3c.1-2.6 1.5-5 3.8-6.3m4.7 4.3c-1-.4-2-.2-2.8.6a2.6 2.6 0 0 0 1.8 4.4A2.5 2.5 0 0 0 10 7.7c0-1-.6-2-1.5-2.4"
})));
export default SvgLocation;